import { defineMessages } from 'react-intl';

export default defineMessages({
    addPoliciesHeader: {
        id: 'portal.views.add-policy-modal.Add Policies to Your Profile',
        defaultMessage: 'Add Policies to Your Profile'
    },
    useFormToAddPolicies: {
        id: 'portal.views.add-policy-modal.Use the form below to add additional policies to your profile.',
        defaultMessage: 'Use the form below to add additional policies to your profile.'
    },
    accountOrPolicyNumber: {
        id: 'portal.views.add-policy-modal.Account or Policy Number:',
        defaultMessage: 'Account or Policy Number:'
    },
    enterTheAccountOrPolicyNumberAria: {
        id: 'portal.views.add-policy-modal.Enter the account or policy number aria',
        defaultMessage: 'Enter the account or policy number'
    },
    removeNumberAria: {
        id: 'portal.views.add-policy-modal.remove number aria',
        defaultMessage: 'Remove {selectedNumber} from the list of entered account or policy numbers for linking.'
    },
    addAnotherPolicy: {
        id: 'portal.views.add-policy-modal.Add another policy',
        defaultMessage: '+ Add another policy'
    },
    policyNumberLocation: {
        id: 'portal.views.add-policy-modal.Policy Number Location',
        defaultMessage: 'Policy Number Location'
    },
    cancel: {
        id: 'portal.views.add-policy-modal.Cancel',
        defaultMessage: 'Cancel'
    },
    close: {
        id: 'portal.views.add-policy-modal.Close',
        defaultMessage: 'Close'
    },
    next: {
        id: 'portal.views.add-policy-modal.Next',
        defaultMessage: 'Next'
    },
    submit: {
        id: 'wmic.components.addPolicyConsentModal.submit',
        defaultMessage: 'Submit'
    },
    missingPolicy: {
        id: 'portal.views.add-policy-modal.Please enter your Account or Policy number.',
        defaultMessage: 'Please enter your Account or Policy number.'
    },
    wrongPolicy: {
        id: 'portal.views.add-policy-modal.Please enter a valid Account or Policy number.',
        defaultMessage: 'Please enter a valid Account or Policy number.'
    },
    duplicatedPolicy: {
        id: 'portal.views.add-policy-modal.The number entered is a duplicate. Please enter another Account or Policy number.',
        defaultMessage: 'The number entered is a duplicate. Please enter another Account or Policy number.'
    },
    addMorePolicies: {
        id: 'portal.views.add-policy-modal.Add More Policies',
        defaultMessage: 'Add More Policies'
    },
    unableToAddPolicies: {
        id: 'portal.views.add-policy-modal.We were unable to add additional policies based on the information you provided.',
        defaultMessage: 'We were unable to add additional policies based on the information you provided.'
    },
    youEnteredTheFollowing: {
        id: 'portal.views.add-policy-modal.You entered the following information:',
        defaultMessage: 'You entered the following information: {info}.'
    },
    foundPolicies: {
        id: 'portal.views.add-policy-modal.We were able to add the following policies to your portal account based on the information you provided.',
        defaultMessage: 'We were able to add the following policies to your portal account based on the information you provided.'
    },
    setContactPreference: {
        id: 'wmic.components.addPolicyConsentModal.Set Your Contact Preference',
        defaultMessage: 'Set Your Contact Preference'
    },
    paragraphOne: {
        id: 'wmic.components.addPolicyConsentModal.paragraphOne',
        defaultMessage: 'We\'ve found the following policies with the information you\'ve provided:'
    },
    paragraphTwo: {
        id: 'wmic.components.addPolicyConsentModal.paragraphTwo',
        defaultMessage: 'To complete linking your policies, confirm your preferred method of contact for all of your policies, including the policies currently listed in your online account.'
    },
    preferredMethodOfContact: {
        id: 'wmic.components.addPolicyConsentModal.preferredMethodOfContact',
        defaultMessage: 'Preferred Method of Contact'
    },
    consentParagraph: {
        id: 'wmic.components.addPolicyConsentModal.consentParagraph',
        defaultMessage: 'With your consent, W\u00A0Insurance will electronically deliver your policy documents, forms, endorsements, billing statements, notices, claim-related documents, and any other documents and communications permitted or required by law. Your consent is voluntary. You can email us at &lt;a href="mailto:service@w-insurance.com"&gt;service@w-insurance.com&lt;/a&gt; or call us at &lt;a href="tel:800-640-2920"&gt;800.640.2920&lt;/a&gt; to opt-out of receiving electronic delivery of your documents at any time, to update your email address to ensure you receive all communications or request free paper copies of your documents. Please note that to receive these documents electronically, you need to have internet access, an active email account, an active online account through the W\u00A0Insurance website, and the ability to open attachments, such as pdf files. By selecting electronic delivery, you understand and agree that we may provide you an e-mail with a link to our website when a Communication is available to view, print and save. It is your responsibility to view your Communications by logging onto your online account at &lt;a href="https://w-insurance.com/"&gt;w-insurance.com&lt;/a&gt; using your username and password that you created to access this website. Certain Communications may be available online only for a limited time period. We may also send you Communications directly by e-mail. You agree that the foregoing electronic process constitutes delivery of the Communications to you in a form that you can retain and will have the same force and effect as if the Communications were sent to you in paper form.'
    },
    consentQuestion: {
        id: 'wmic.components.addPolicyConsentModal.consentQuestion',
        defaultMessage: 'Would you like to receive your documents and communication electronically?'
    },
    consentQuestionDescriptionAria: {
        id: 'wmic.components.addPolicyConsentModal.consentQuestionDescriptionAria',
        defaultMessage: 'Choose your document delivery preference given the two choices below.'
    },
    enteredPolicyNumberToTheListAria: {
        id: 'wmic.components.addPolicyConsentModal.enteredPolicyNumberToTheListAria',
        defaultMessage: 'Entered {pNumber} to the list'
    },
    consentYes: {
        id: 'wmic.components.addPolicyConsentModal.consentYes',
        defaultMessage: '&lt;strong&gt;Yes- &lt;/strong&gt;I want to receive my documents electronically. By clicking here, I confirm that I have read the information above and consent to the electronic delivery of documents and communications from W\u00A0Insurance which will be sent to {email}.'
    },
    consentNo: {
        id: 'wmic.components.addPolicyConsentModal.consentNo',
        defaultMessage: '&lt;strong&gt;No&lt;/strong&gt;- I do not want to receive my documents electronically and want to receive communications via US mail.'
    },
    logAddingPolicyNumbers: {
        id: 'wmic.components.addPolicyConsentModal.Adding Policy Numbers to the list',
        defaultMessage: 'Adding {policyNumbers} to the list'
    },
    logUnhandledError: {
        id: 'wmic.components.addPolicyConsentModal.Possibly unhandled rejection',
        defaultMessage: 'Possibly unhandled rejection'
    },
    back: {
        id: 'portal.views.add-policy-modal.Back',
        defaultMessage: 'Back'
    }
});